import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-arch-dataflow',
	templateUrl:'./DataFlowPage.html',
	styles: [],
	styleUrls:['./DataFlowPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class DataFlowPage
{
	mdContent_29 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
sequenceDiagram
  participant B as 🌐 Browser
  participant V as ⚡ Vert.x Server
  participant H as ☕ Java Handler

  rect rgba(99, 102, 241, 0.1)
  Note over B,V: Page Delivery
  B->>V: GET /dashboard
  V-->>B: index.html + dist/ assets
  end

  rect rgba(52, 211, 153, 0.1)
  Note over B,H: AJAX Event Cycle
  B->>V: POST /jwajax
  V->>H: deserialize AjaxCall
  H->>H: intercept → fireEvent()
  H-->>V: AjaxResponse
  V-->>B: DOM update instructions
  end

  rect rgba(248, 113, 113, 0.1)
  Note over B,H: Real-Time Push
  B->>V: WS /eventbus STOMP
  V->>H: RabbitMQ exchange
  V-->>B: STOMP message push
  end

\`\`\``;
}
